import React from 'react';
import { get } from 'lodash/fp';
import { useStoreState } from 'easy-peasy';
import { Box } from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import Layout from '../../components/Layout';
import Form from './Form';
import PageLoading from '../../components/PageLoading';
import PageHeading from '../../components/PageHeading';
import PageSection from '../../components/PageSection';

export default function GuestEditProfile() {
  const { data: userDetails, loading } = useStoreState(get('userDetails'));

  return (
    <Layout>
      {!userDetails && loading ? (
        <PageLoading />
      ) : (
        <>
          {!get('firstName', userDetails) && (
            <Box mb={2} mt={1}>
              <Alert severity="info">
                <AlertTitle>Complete Your Profile</AlertTitle>
                Guest Details below are needed to complete your reservation.
              </Alert>
            </Box>
          )}
          <PageHeading>Guest Details</PageHeading>
          <PageSection>
            <Form userDetails={userDetails} />
          </PageSection>
        </>
      )}
    </Layout>
  );
}
